
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";
import { Button, Paper } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
// import toast, { Toaster } from 'react-hot-toast';
import { getCity, getCountry, getEmployee, getGender, getIdProof, getResidentialCity, getResidentialCountry, getResidentialState, getState, getDepartment, getDesignation, getRoleList, getUserList } from '../../../Redux/action/Admin/EmployeeMasterAction';
import axios from 'axios';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getModuleDetail, getRoleModuleDetail } from '../../../Redux/action/Admin/EmployeeAction';
import { adminMainUrl } from '../../../Config';
const AddEmployee = ({ show, handleClose, employeeData, loadingEmployeeApi }) => {
    
    {/* Basic Info */ }
    const today = new Date();
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    const [startDate, setStartDate] = useState(eighteenYearsAgo);
    const [cheque, setCheque] = useState(null);
    const [adminProfile, setAdminProfile] = useState(null);

    const dispatch = useDispatch();
    let [genderOptions, setGenderOptions] = useState([]);
    let [idProofOptions, setIdProofOptions] = useState([]);
    let [sameAddress, setSameAddress] = useState(false);
    let [countryOptions, setCountryOptions] = useState([]);
    let [stateOptions, setStateOptions] = useState([]);
    let [cityOptions, setCityOptions] = useState([]);
    let [residentialCountryOptions, setResidentialCountryOptions] = useState([]);
    let [residentialStateOptions, setResidentialStateOptions] = useState([]);
    let [residentialCityOptions, setResidentialCityOptions] = useState([]);
    let [disable, setDisable] = useState(false);
    let [showLoader, setShowLoader] = useState(true);
    let [profileImagePath, setProfileImagePath] = useState("/img/profile.png");


    useEffect(() => {

        if (loadingEmployeeApi) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

    }, [loadingEmployeeApi]);


    useEffect(() => {
        //get masters data
        dispatch(getGender());
        dispatch(getIdProof());
        dispatch(getCountry());
        dispatch(getResidentialCountry());

    }, []);


    const handleGetState = (id) => {
        try {
            if (id) {
                dispatch(getState(id));
            }
        } catch (error) {
            console.log("Error in handleGetState function:", error.message);
        }
    };

    const handleGetResidentialState = (id) => {
        try {
            if (id) {
                dispatch(getResidentialState(id));
            }
        } catch (error) {
            console.log("Error in handleGetResidentialState function:", error.message);
        }
    };

    const handleGetCity = (id) => {
        try {
            if (id) {
                dispatch(getCity(id));
            }
        } catch (error) {
            console.log("Error in handleGetCity function:", error.message);
        }
    }
    const handleGetResidentialCity = (id) => {
        try {
            if (id) {
                dispatch(getResidentialCity(id));
            }
        } catch (error) {
            console.log("Error in handleGetResidentialCity function:", error.message);
        }
    }


    //master -> Gender
    let genderData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.genderData : []);

    useEffect(() => {
        if (genderData) {
            let genderArr = [];
            genderData.map(val => { if (val.status) { genderArr.push({ value: val.id, label: val.name }) } });
            setGenderOptions(genderArr);
        }
    }, [genderData]);

    //master-> id proof
    let idproofData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.idproofData : []);
    useEffect(() => {
        if (idproofData) {
            let idproofArr = [];
            idproofData.map(val => { if (val.status) { idproofArr.push({ value: val.id, label: val.name }) } });
            setIdProofOptions(idproofArr);
        }
    }, [idproofData]);


    //master-> country
    let countryData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.countryData : []);
    useEffect(() => {
        if (countryData) {
            let countryArr = [];
            countryData.map(val => { if (val.status) { countryArr.push({ value: val.id, label: val.name }) } });
            setCountryOptions(countryArr);
        }
    }, [countryData]);

    //master-> state
    let stateData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.stateData : []);
    useEffect(() => {
        if (stateData) {
            let stateArr = [];
            stateData.map(val => { stateArr.push({ value: val.id, label: val.name }) });
            setStateOptions(stateArr);
        }
    }, [stateData]);

    //master-> city
    let cityData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.cityData : []);
    useEffect(() => {
        if (cityData) {
            let cityArr = [];
            cityData.map(val => { cityArr.push({ value: val.id, label: val.name }) });
            setCityOptions(cityArr);
        }
    }, [cityData]);

    //master-> residential country
    let residentialCountryData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.residentialCountryData : []);
    useEffect(() => {
        if (residentialCountryData) {
            let residentialCountryArr = [];
            residentialCountryData.map(val => { if (val.status) { residentialCountryArr.push({ value: val.id, label: val.name }) } });
            setResidentialCountryOptions(residentialCountryArr);
        }
    }, [residentialCountryData]);

    //master-> residential state
    let residentialStateData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.residentialStateData : []);
    useEffect(() => {
        if (residentialStateData) {
            let residentialStateArr = [];
            residentialStateData.map(val => { residentialStateArr.push({ value: val.id, label: val.name }) });
            setResidentialStateOptions(residentialStateArr);
        }
    }, [residentialStateData]);

    //master->residential city
    let residentialCityData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.residentialCityData : []);
    useEffect(() => {
        if (residentialCityData) {
            let residentialCityArr = [];
            residentialCityData.map(val => { residentialCityArr.push({ value: val.id, label: val.name }) });
            setResidentialCityOptions(residentialCityArr);
        }
    }, [residentialCityData]);

    //get employee details
    // let { employeeData, loadingEmployeeApi } = useSelector(state => state?.EmployeeMasterReducer);

    const maritalStatusOptions = [
        { value: 'Married', label: 'Married' },
        { value: 'Unmarried', label: 'Unmarried' },
    ]

    const handleCheque = (event) => {
        const file = event.target.files[0];
        // formik.setFieldValue("warranty_doc", file);
        setCheque(file);
    };

    const handleRemoveCheque = () => {
        // formik.setFieldValue("warranty_doc", null);
        setCheque(null);
    };

    let initialValues = {
        user_id: employeeData?.userInfo?.id,
        profile_image: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        DOB: startDate,
        gender_id: "",
        marital_status: "",
        contact_number: "",
        contact_email: "",
        proof_type_id: "",
        proof_id_number: "",
        same_as_permanent_address: false,
        street_number: "",
        street: "",
        country_id: "",
        state_id: "",
        city_id: "",
        postal_code: "",
        r_street_number: "",
        r_street: "",
        r_country_id: "",
        r_state_id: "",
        r_city_id: "",
        r_postal_code: "",
        // official
        department_id: "",
        designation_id: "",
        role_id: "",
        reporting_user_id: [],
        offical_contact_number: "",
        offical_contact_email: "",
        permissionList: [],
        // account
        username: "",
        password: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: Yup.object({
            profile_image: Yup.string().required("Please select profile image"),
            first_name: Yup.string().required("Please enter first name."),
            last_name: Yup.string().required("Please enter last name."),
            DOB: Yup.date().required("Please select DOB."),
            gender_id: Yup.string().required('Please select gender.'),
            marital_status: Yup.string().required('Please select marital status.'),
            contact_number: Yup.string().required("Please enter contact number."),
            contact_email: Yup.string().required("Please enter email-id.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
            proof_type_id: Yup.string().required('Please select ID proof.'),
            proof_id_number: Yup.string().required("Please enter ID number."),
            street_number: Yup.string().required("Please enter street number."),
            street: Yup.string().required("Please enter street."),
            country_id: Yup.string().required('Please select country.'),
            state_id: Yup.string().required('Please select state.'),
            city_id: Yup.string().required('Please select city.'),
            postal_code: Yup.string().required("Please enter postal code."),
            r_street_number: !sameAddress ? Yup.string().required("Please enter street number.") : Yup.string(),
            r_street: !sameAddress ? Yup.string().required("Please enter street.") : Yup.string(),
            r_country_id: !sameAddress ? Yup.string().required('Please select country.') : Yup.string(),
            r_state_id: !sameAddress ? Yup.string().required('Please select state.') : Yup.string(),
            r_city_id: !sameAddress ? Yup.string().required('Please select city.') : Yup.string(),
            r_postal_code: !sameAddress ? Yup.string().required("Please enter postal code.") : Yup.string(),

            // official
            department_id: Yup.string().required("Please select department."),
            designation_id: Yup.string().required("Please select designation."),
            role_id: Yup.string().required("Please select role."),
            offical_contact_number: Yup.string().required('Please enter official contact number.'),
            offical_contact_email: Yup.string().required('Please enter official email.').matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
            permissionList: Yup.array().min(1, 'At least one permission must be selected'),

            // account
            username: Yup.string().required('Please enter username.'),
            password: Yup.string().required('Please enter password.'),
        }),
        onSubmit: (values, { resetForm }) => {
            const convertedPermission = values.permissionList.reduce((acc, current) => {
                const existingModule = acc.find((module) => module.module_short_name === current.module_short_name);
                if (existingModule) {
                    existingModule.permission_list.push({ permission_short_name: current.permission_short_name });
                } else {
                    acc.push({
                        module_short_name: current.module_short_name,
                        permission_list: [{ permission_short_name: current.permission_short_name }]
                    });
                }
                return acc;
            }, []);

            values.permissionList = convertedPermission;
            values.user_id = employeeData?.userInfo?.id;
            setDisable(true);
            try {


                const formData = new FormData();
                formData.append("user_id", values.user_id);
                formData.append("first_name", values.first_name);
                formData.append("middle_name", values.middle_name);
                formData.append("last_name", values.last_name);
                formData.append("DOB", values.DOB);
                formData.append("gender_id", values.gender_id);
                formData.append("marital_status", values.marital_status);
                formData.append("contact_number", values.contact_number);
                formData.append("contact_email", values.contact_email);
                formData.append("proof_type_id", values.proof_type_id);
                formData.append("proof_id_number", values.proof_id_number);
                formData.append("street_number", values.street_number);
                formData.append("street", values.street);
                formData.append("country_id", values.country_id);
                formData.append("state_id", values.state_id);
                formData.append("city_id", values.city_id);
                formData.append("postal_code", values.postal_code);
                formData.append("same_as_permanent_address", values.same_as_permanent_address ? 1 : 0);
                formData.append("r_street_number", values.r_street_number);
                formData.append("r_street", values.r_street);
                formData.append("r_country_id", values.r_country_id);
                formData.append("r_state_id", values.r_state_id);
                formData.append("r_city_id", values.r_city_id);
                formData.append("r_postal_code", values.r_postal_code);
                formData.append("profile_image", values.profile_image);
                // official
                formData.append("department_id", values.department_id);
                formData.append("designation_id", values.designation_id);
                formData.append("offical_contact_number", values.offical_contact_number);
                formData.append("role_id", values.role_id);
                formData.append("offical_contact_email", values.offical_contact_email);
                formData.append("reporting_user_id", JSON.stringify(values.reporting_user_id));
                // Convert permissionList to JSON string
                formData.append("permissionList", JSON.stringify(values.permissionList));
                formData.append("username", values.username);
                formData.append("password", values.password);

                let config = { headers: { "auth-token": Cookies.get('token'), 'content-type': 'multipart/form-data', } };

                axios.post(`${adminMainUrl}/api/employee/update-employee-all-detail`, formData, config)
                    .then(res => {
                        if (res.status === 200) {
                            Cookies.set("emply_id", res?.data?.data?.emply_id);
                            resetForm();
                            setProfileImagePath("/img/profile.png");
                            handleClose();
                            toast.success(res.data.msg);
                            setDisable(false);
                        } else {
                            toast.error(res.data.msg);
                            setDisable(false);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        if (err.response) {
                            toast.error(err.response.data.msg);
                        } else {
                            toast.error("Internal server error.")
                        }
                        setDisable(false);
                    });

            } catch (error) {
                console.log(error);
                toast.error(error.response.data.msg);
                setDisable(false);
            }
        }

    });


    let emply_id = employeeData?.userInfo?.id;

    useEffect(() => {

        if (employeeData && employeeData?.userInfo) {
            if (employeeData?.userInfo.EmplyPermanentAddress) {
                if (employeeData?.userInfo?.EmplyPermanentAddress?.country_id) {
                    handleGetState(Number(employeeData?.userInfo?.EmplyPermanentAddress?.country_id))
                }
                if (employeeData?.userInfo?.EmplyPermanentAddress?.state_id) {
                    handleGetCity(Number(employeeData?.userInfo?.EmplyPermanentAddress?.state_id));
                }
            }
            if (employeeData?.userInfo.EmplyResidentialAddress) {
                if (employeeData?.userInfo?.EmplyResidentialAddress?.country_id) {
                    handleGetResidentialState(Number(employeeData?.userInfo?.EmplyResidentialAddress?.country_id));
                }
                if (employeeData?.userInfo?.EmplyResidentialAddress?.state_id) {
                    handleGetResidentialCity(Number(employeeData?.userInfo?.EmplyResidentialAddress?.state_id));
                }
            }
            if (employeeData?.userInfo?.same_as_permanent_address) {
                setSameAddress(true);
            } else {
                setSameAddress(false);
            };

            //change profile image path:
            setProfileImagePath(`${adminMainUrl}/${employeeData?.userInfo?.profile_image}`)

            if (employeeData?.userInfo?.DOB) {
                const date = new Date(employeeData?.userInfo?.DOB);
                setStartDate(date);
            }


            formik.setValues({
                profile_image: employeeData?.userInfo?.profile_image ?? "",
                first_name: employeeData?.userInfo.first_name ?? "",
                middle_name: employeeData?.userInfo.middle_name ?? "",
                last_name: employeeData?.userInfo.last_name ?? "",
                DOB: employeeData?.userInfo.DOB ? employeeData?.userInfo.DOB?.split('T')[0] : initialValues.DOB,
                gender_id: employeeData?.userInfo.gender_id ?? "",
                marital_status: employeeData?.userInfo.marital_status ?? "",
                contact_number: employeeData?.userInfo.contact_number ?? "",
                contact_email: employeeData?.userInfo.contact_email ?? "",
                proof_type_id: employeeData?.userInfo.proof_type_id ?? "",
                proof_id_number: employeeData?.userInfo.proof_id_number ?? "",
                same_as_permanent_address: employeeData?.userInfo.same_as_permanent_address ?? false,
                street_number: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo.EmplyPermanentAddress?.street_number ?? "" : "",
                street: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo?.EmplyPermanentAddress?.street ?? "" : "",
                country_id: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo?.EmplyPermanentAddress?.country_id ?? "" : "",
                state_id: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo?.EmplyPermanentAddress?.state_id ?? "" : "",
                city_id: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo?.EmplyPermanentAddress?.city ?? "" : "",
                postal_code: employeeData?.userInfo?.EmplyPermanentAddress ? employeeData?.userInfo?.EmplyPermanentAddress?.postal_code ?? "" : "",
                r_street_number: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo.EmplyResidentialAddress?.street_number ?? "" : "",
                r_street: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo?.EmplyResidentialAddress?.street ?? "" : "",
                r_country_id: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo?.EmplyResidentialAddress?.country_id ?? "" : "",
                r_state_id: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo?.EmplyResidentialAddress?.state_id ?? "" : "",
                r_city_id: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo?.EmplyResidentialAddress?.city ?? "" : "",
                r_postal_code: employeeData?.userInfo?.EmplyResidentialAddress ? employeeData?.userInfo?.EmplyResidentialAddress?.postal_code ?? "" : "",

                // official
                department_id: employeeData?.userInfo?.department_id ? employeeData?.userInfo?.department_id : "",
                designation_id: employeeData?.userInfo?.designation_id ? employeeData?.userInfo?.designation_id : "",
                role_id: employeeData?.userInfo?.role_id ? employeeData?.userInfo?.role_id : "",
                offical_contact_number: employeeData?.userInfo?.offical_contact_number ?? "",
                offical_contact_email: employeeData?.userInfo?.offical_contact_email ?? "",
                // permissionList: employeeData?.transformedPermissions ?? "",

                // account
                username: employeeData?.userInfo?.username ?? "",
                password: employeeData?.userInfo?.show_password ?? "",
            });

            if (employeeData?.userInfo?.user_reporting_list && Array.isArray(employeeData?.userInfo?.user_reporting_list)) {
               
                formik.setFieldValue("reporting_user_id", employeeData?.userInfo?.user_reporting_list?.map(man => man?.reporting_user_info?.id))
            }


            if (employeeData?.userInfo?.role_id) {
                setViewPermissions(true);
                dispatch(getRoleModuleDetail(employeeData?.userInfo?.role_id, emply_id));
            } else {
                setViewPermissions(false);
            }
        }

    }, [employeeData, loadingEmployeeApi]);

    const handleAdminProfile = (event) => {
        const file = event.target.files[0];

        let allowedExtensions = ['png', 'jpg', 'jpeg'];

        if (file && !allowedExtensions?.includes(file?.name?.split('.').pop().toLowerCase())) {
            toast.error("Please enter a valid image.")
        } else if (file && (file.size / (1024 * 1024)) > 5) {
            toast.error("Image size should be less than 5 MB.")
        } else if (file) {
            setAdminProfile(file);
            formik.setFieldValue("profile_image", event.target.files[0]);
        } else {
            toast.error("Please upload profile image")
        }
    };
    {/* Basic Info */ }


    let [departmentOptions, setDepartmentOptions] = useState([]);
    let [designationOptions, setDesignationOptions] = useState([]);
    let [roleOptions, setRoleOptions] = useState([]);
    let [userOptions, setUserOptions] = useState([]);



    let [viewPermissions, setViewPermissions] = useState(false);
    // let [detail, setDetail] = useState({});
    let [permissionList, setPermissionList] = useState({
        assignModules: [],
        notAssignModules: [],
    });



    useEffect(() => {
        //get masters data
        // dispatch(getDepartment());
        // dispatch(getDesignation());
        // dispatch(getRoleList());
        // dispatch(getUserList());
    }, []);

    //master -> department
    let departmentData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.departmentData : []);

    useEffect(() => {
        if (departmentData) {
            let departmentArr = [];
            departmentData.map(val => { if (val.status) { departmentArr.push({ value: val.id, label: val.name }) } });
            setDepartmentOptions(departmentArr);
        }
    }, [departmentData]);

    //master -> designation

    let roleData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.roleListData : []);

    useEffect(() => {
        if (roleData) {
            let roleArr = [];
            roleData.map(val => { roleArr.push({ value: val.id, label: val.name }) });
            setRoleOptions(roleArr);
        }
    }, [roleData]);

    //master -> role
    let userData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.viewUserData : []);

    useEffect(() => {
        if (userData) {
            let userArr = [];
            // userData.map(val => { userArr.push({ value: val.id, label: `${val.first_name} ${val.middle_name} ${val?.last_name} (${val?.unique_id})` }) });
            userData.forEach(val => {
                // Only push to userArr if val.id is not equal to the employeeId
                if (val.id !== Cookies.get("emply_id")) {
                    userArr.push({
                        value: val.id,
                        label: `${val.first_name} ${val.middle_name} ${val?.last_name} (${val?.unique_id})`
                    });
                }
            });
            setUserOptions(userArr);
        }
    }, [userData]);

    //master -> role
    let designationData = useSelector(state => state?.EmployeeMasterReducer ? state?.EmployeeMasterReducer?.designationData : []);

    useEffect(() => {
        if (designationData) {
            let designationArr = [];
            designationData.map(val => { if (val.status) { designationArr.push({ value: val.id, label: val.name }) } });
            setDesignationOptions(designationArr);
        }
    }, [designationData]);









    const handleRolePerm = (id) => {
        dispatch(getRoleModuleDetail(id, emply_id));
    }

    //permissions getting
    let { loadingRoleModuleDetail, roleModuleDetailDataError, roleModuleDetailData } = useSelector(state => state?.EmployeeReducer);

    useEffect(() => {
        if (loadingRoleModuleDetail) {
            setViewPermissions(false);
        } else {
            setViewPermissions(true);
        };

        if (roleModuleDetailData) {

            setPermissionList({
                assignModules: roleModuleDetailData.assignModules,
                notAssignModules: roleModuleDetailData.notAssignModule,
            });

            // let result = [];
            // // Combine assignModules and notAssignModule arrays
            // if (roleModuleDetailData.assignModules && roleModuleDetailData.notAssignModule) {
            //   const allModules = [...roleModuleDetailData.assignModules, ...roleModuleDetailData.notAssignModule];
            //   // Function to filter permissions with assign_permission = true


            //   result = allModules.flatMap(module =>
            //     module.permission
            //       .filter(permission => permission.assign_permission) // Only permissions with assign_permission = true
            //       .map(permission => ({
            //         module_short_name: module.short_name, // Module short name
            //         permission_short_name: permission.short_name // Permission short name
            //       }))
            //   );

            //   console.log("result", result);
            // }

            // formik.setFieldValue("permissionList", result);
        }


    }, [loadingRoleModuleDetail, roleModuleDetailDataError, roleModuleDetailData]);








    const handleRoleChange = (option) => {
        formik.setFieldValue('role_id', option.value);
        formik.setFieldValue('permissionList', []);
        handleRolePerm(option.value);
    };





    // Tooltip
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Upto 2 Reporting Managers can be added.
        </Tooltip>
    );


    const handlePermissionChange = (moduleType, moduleIndex, permIndex, isChecked) => {
        const updatedList = { ...permissionList };
        const selectedModule = updatedList[moduleType][moduleIndex];

        // Update the specific permission
        selectedModule.permission[permIndex].assign_permission = isChecked;

        // Ensure permissionList is an array
        let updatedPermissionList = Array.isArray(formik.values.permissionList) ? [...formik.values.permissionList] : [];

        const permissionShortName = selectedModule.permission[permIndex].short_name;
        const moduleShortName = selectedModule.short_name;

        if (isChecked) {
            updatedPermissionList.push({
                module_short_name: moduleShortName,
                permission_short_name: permissionShortName,
            });
        } else {
            updatedPermissionList = updatedPermissionList.filter(
                (perm) => !(perm.module_short_name === moduleShortName && perm.permission_short_name === permissionShortName)
            );
        }

        formik.setFieldValue('permissionList', updatedPermissionList);

        // Check if all permissions in the module are selected
        const allChecked = selectedModule.permission.every((perm) => perm.assign_permission);
        selectedModule.allPermissionsChecked = allChecked;

        setPermissionList(updatedList);

    };




    const handleModuleHeadChange = (moduleType, moduleIndex, isChecked) => {
        const updatedList = { ...permissionList };
        const selectedModule = updatedList[moduleType][moduleIndex];

        // Update all permissions inside the module
        selectedModule.permission = selectedModule.permission.map((perm) => ({
            ...perm,
            assign_permission: isChecked,
        }));

        // Ensure permissionList is an array
        let updatedPermissionList = Array.isArray(formik.values.permissionList) ? [...formik.values.permissionList] : [];

        selectedModule.permission.forEach((perm) => {
            const permissionShortName = perm.short_name;
            const moduleShortName = selectedModule.short_name;

            if (isChecked) {
                // Check if the permission already exists to avoid duplicates
                if (!updatedPermissionList.some(p => p.permission_short_name === permissionShortName && p.module_short_name === moduleShortName)) {
                    updatedPermissionList.push({
                        module_short_name: moduleShortName,
                        permission_short_name: permissionShortName,
                    });
                }
            } else {
                updatedPermissionList = updatedPermissionList.filter(
                    (perm) => !(perm.module_short_name === moduleShortName && perm.permission_short_name === permissionShortName)
                );
            }
        });

        formik.setFieldValue('permissionList', updatedPermissionList);

        // Set the "all checked" status for the module
        selectedModule.allPermissionsChecked = isChecked;

        setPermissionList(updatedList);
    };

    const renderPermissions = (modules = [], moduleType) => {
        return modules.map((module, moduleIndex) => (
            <div key={moduleIndex} className="col-md-6 mb-3">
                <div
                    className="table-responsive role_css acl-role"
                    style={{ height: '200px', overflowY: 'scroll', margin: '10px 0px' }}
                >
                    <table className="table table-striped permission_table">
                        <thead>
                            <tr>
                                <th>{module.name}</th>
                                <th style={{ width: 40 }}>
                                    <input
                                        type="checkbox"
                                        className="modulePerm"
                                        name={module.short_name}
                                        title={`Click on this box to Select/Unselect all permissions of ${module.name}`}
                                        style={{ cursor: 'pointer' }}
                                        checked={module.allPermissionsChecked || false}
                                        onChange={(e) => handleModuleHeadChange(moduleType, moduleIndex, e.target.checked)}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {module.permission.map((permission, permIndex) => (
                                <tr key={permIndex}>
                                    <td>{permission.name}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            style={{ cursor: 'pointer' }}
                                            name={permission.short_name}
                                            checked={permission.assign_permission || false}
                                            onChange={(e) => handlePermissionChange(moduleType, moduleIndex, permIndex, e.target.checked)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        ));
    };

    useEffect(() => {
        if (permissionList) {
            let initialPermissionList = [];
            const updatedAssignModules = permissionList.assignModules?.map(module => {
                const allChecked = module.permission?.every(permission => permission.assign_permission);
                // Only update `allPermissionsChecked` if it changes
                if (module.allPermissionsChecked !== allChecked) {
                    return {
                        ...module,
                        allPermissionsChecked: allChecked,
                    };
                }
                return module; // Return the module unchanged if the state is the same
            });

            // Loop through each assigned module and permission
            updatedAssignModules?.forEach((module) => {
                module.permission?.forEach((permission) => {
                    if (permission.assign_permission) {
                        initialPermissionList?.push({
                            module_short_name: module.short_name,
                            permission_short_name: permission.short_name,
                        });
                    }
                });
            });

            // Loop through each not assigned module and permission
            if (permissionList.notAssignModules) {
                permissionList.notAssignModules?.forEach((module) => {
                    const allChecked = module.permission?.every(permission => permission.assign_permission);
                    // Only update `allPermissionsChecked` if it changes
                    if (module.allPermissionsChecked !== allChecked) {
                        module.allPermissionsChecked = allChecked;
                    }

                    module?.permission?.forEach((permission) => {
                        if (permission.assign_permission) {
                            initialPermissionList?.push({
                                module_short_name: module.short_name,
                                permission_short_name: permission.short_name,
                            });
                        }
                    });
                });
            }

            // Update the permissionList state only if it changes
            const newPermissionList = {
                assignModules: updatedAssignModules,
                notAssignModules: permissionList.notAssignModules,
            };

            if (JSON.stringify(newPermissionList) !== JSON.stringify(permissionList)) {
                setPermissionList(newPermissionList);
            }

            // Set the Formik field value only if it changes
            if (JSON.stringify(initialPermissionList) !== JSON.stringify(formik.values.permissionList)) {
                formik.setFieldValue('permissionList', initialPermissionList);
            }
        }
    }, [permissionList, formik]);




    // account credentials


    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Employee Form</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="accordion" id="main_accordion">

                    {
                        showLoader ?
                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                <BeatLoader />
                            </div> :
                            <form onSubmit={formik.handleSubmit}>
                                <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">

                                    <FocusError formik={formik} />
                                    {/* Personal Details */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                                            <span className="avatar avatar-md rounded text-dark border me-2">
                                                <i className="ti ti-user-plus fs-20" />
                                            </span>
                                            Personal Details
                                        </Accordion.Header>
                                        <Accordion.Body className="accordion-body border-top my-0">
                                            <>


                                                <div className="main_detail_form section1" id="section1">

                                                    <div className="main-nav-det">
                                                        <div className="admin_profile_photo_main just_center mb-3">
                                                            <div className="admin_profile_photo">
                                                                <span className="admin_profile_photo_img">
                                                                    {
                                                                        adminProfile ?
                                                                            <img
                                                                                src={URL.createObjectURL(adminProfile)}
                                                                                alt="Selected"
                                                                                title="accpeted files .jpg,.jpeg,.png, Max size 5MB"
                                                                            />
                                                                            : <img src={profileImagePath ? profileImagePath : `/img/no-profile-img.png`}
                                                                                onError={({ currentTarget }) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = "/img/no-profile-img.png";
                                                                                }}
                                                                                title="accpeted files .jpg,.jpeg,.png, Max size 5MB"
                                                                                alt="profile" />
                                                                    }</span>

                                                                <span className="admin_pro_add_img" title="accpeted files .jpg,.jpeg,.png, Max size 5MB"><img src="/img/img_put.png" alt="" />
                                                                    <input

                                                                        type="file"
                                                                        name="profile_image"
                                                                        className="form-control form-control-sm mb-1 form-control-admin"
                                                                        placeholder="Upload Here"
                                                                        onChange={(e) => {
                                                                            handleAdminProfile(e);
                                                                        }}
                                                                        onBlur={formik.handleBlur}
                                                                    />
                                                                </span>
                                                                <div className="help-block with-errors">
                                                                    {formik.touched.profile_image && formik.errors.profile_image ? (
                                                                        <div className='text-danger small'>{formik.errors.profile_image}</div>
                                                                    ) : null}
                                                                </div>

                                                            </div>
                                                        </div>
                                                        {emply_id && <div className='admin-emp-id'>
                                                            <p>EMP ID : <span>{employeeData?.userInfo?.unique_id}</span> </p>
                                                        </div>}
                                                        <div className="admin_form_detail">
                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section">
                                                                        <label className='form-label'>First Name <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter first name"
                                                                            name='first_name'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.first_name}
                                                                            maxLength={30}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.first_name && formik.errors.first_name ? (
                                                                                <div className='text-danger small'>{formik.errors.first_name}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Middle Name </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter middle name"
                                                                            name='middle_name'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.middle_name}
                                                                            maxLength={30}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.middle_name && formik.errors.middle_name ? (
                                                                                <div className='text-danger small'>{formik.errors.middle_name}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Last Name <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter last name"
                                                                            name='last_name'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.last_name}
                                                                            maxLength={30}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.last_name && formik.errors.last_name ? (
                                                                                <div className='text-danger small'>{formik.errors.last_name}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>DOB <span className="text-danger">*</span></label>
                                                                        <div className="det_detail_main">
                                                                            <div className="custom-datepicker">
                                                                                <DatePicker
                                                                                    selected={startDate}
                                                                                    name='DOB'
                                                                                    onChange={(date) => {
                                                                                        setStartDate(date);
                                                                                        // Convert date to YYYY-MM-DD format
                                                                                        const formattedDate = date.toISOString().split('T')[0];
                                                                                        formik.setFieldValue('DOB', formattedDate);
                                                                                    }}
                                                                                    onBlur={formik.handleBlur}
                                                                                    value={formik.values.DOB}
                                                                                    maxDate={eighteenYearsAgo}
                                                                                // showYearDropdown
                                                                                // scrollableYearDropdown
                                                                                // showMonthDropdown
                                                                                // yearDropdownItemNumber={100}
                                                                                />
                                                                                <span style={{ top: "13px" }}><img src="/img/date.png" alt="" /></span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.DOB && formik.errors.DOB ? (
                                                                                <div className='text-danger small'>{formik.errors.DOB}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section ">
                                                                        <label className='margin-custom form-label'>Gender <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={genderOptions}
                                                                            name="gender_id"
                                                                            value={genderOptions.find(option => option.value === formik.values.gender_id)}
                                                                            onChange={option => formik.setFieldValue('gender_id', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.gender_id && formik.errors.gender_id ? (
                                                                                <div className='text-danger small'>{formik.errors.gender_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section  ">
                                                                        <label className='margin-custom form-label'>Marital Status <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={maritalStatusOptions}
                                                                            name="maritaltStatus"
                                                                            value={maritalStatusOptions.find(option => option.value === formik.values.marital_status)}
                                                                            onChange={option => formik.setFieldValue('marital_status', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.marital_status && formik.errors.marital_status ? (
                                                                                <div className='text-danger small'>{formik.errors.marital_status}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Contact Number <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter contact number"
                                                                            name="contact_number"
                                                                            onInput={(event) => {
                                                                                let value = event.target.value;
                                                                                value = value.replace(/[^0-9]/g, '');
                                                                                event.target.value = value;
                                                                            }}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.contact_number}
                                                                            maxLength={10}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.contact_number && formik.errors.contact_number ? (
                                                                                <div className='text-danger small'>{formik.errors.contact_number}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>E-mail ID <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter e-mail id"
                                                                            name="contact_email"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.contact_email}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.contact_email && formik.errors.contact_email ? (
                                                                                <div className='text-danger small'>{formik.errors.contact_email}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section">
                                                                        <label className='margin-custom form-label'>ID Proof <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={idProofOptions}
                                                                            name="proof_type_id"
                                                                            value={idProofOptions.find(option => option.value === formik.values.proof_type_id)}
                                                                            onChange={option => formik.setFieldValue('proof_type_id', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.proof_type_id && formik.errors.proof_type_id ? (
                                                                                <div className='text-danger small'>{formik.errors.proof_type_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>ID Number <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter ID Number"
                                                                            name="proof_id_number"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            maxLength={30}
                                                                            value={formik.values.proof_id_number}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.proof_id_number && formik.errors.proof_id_number ? (
                                                                                <div className='text-danger small'>{formik.errors.proof_id_number}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="col-md-6 col-lg-4">
                <div className="input_box_section file-input-main-admin">
                  <label>Copy of cancelled cheque</label>
                  <input type="file" onChange={(event) => handleCheque(event)} name="cancelledCheque" className="form-control form-control-admin"
                    placeholder="Upload Here" />
                  <button className="folder_main_update-admin"> Upload Here <span><img src="/img/upload.png"
                    alt="file" /></span></button>
                </div>
                {cheque && (
                  <div className="border border-[#cac8c8] rounded-md d-flex justify-center items-center relative multiple-img-box">
                    <img

                      className="object-contain h-[100px] w-[100px]"
                      src={URL.createObjectURL(cheque)}
                      alt="Selected"
                    />
                    <CancelIcon
                      className="top-[6px] right-[6px] absolute-img"
                      onClick={handleRemoveCheque}
                    />
                  </div>
                )}
              </div> */}
                                                                <div className="main-nav-det">
                                                                    <h5 className='form-heading-bg'>Permanent Address</h5>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Street Number <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter street number "
                                                                            name="street_number"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.street_number}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.street_number && formik.errors.street_number ? (
                                                                                <div className='text-danger small'>{formik.errors.street_number}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Street <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter street"
                                                                            name="street"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.street}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.street && formik.errors.street ? (
                                                                                <div className='text-danger small'>{formik.errors.street}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section ">
                                                                        <label className='margin-custom form-label'>Country <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={countryOptions}
                                                                            name="country_id"
                                                                            value={countryOptions.find(option => option.value === formik.values.country_id)}
                                                                            onChange={option => { formik.setFieldValue('country_id', option.value); handleGetState(option.value); formik.setFieldValue('state_id', ''); }}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.country_id && formik.errors.country_id ? (
                                                                                <div className='text-danger small'>{formik.errors.country_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section  ">
                                                                        <label className='margin-custom form-label'>State <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={stateOptions}
                                                                            name="state_id"
                                                                            value={stateOptions.find(option => option.value === formik.values.state_id)}
                                                                            onChange={option => { formik.setFieldValue('state_id', option.value); handleGetCity(option.value); formik.setFieldValue('city_id', ''); }}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.state_id && formik.errors.state_id ? (
                                                                                <div className='text-danger small'>{formik.errors.state_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section ">
                                                                        <label className='margin-custom form-label'>City <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={cityOptions}
                                                                            name="city_id"
                                                                            value={cityOptions.find(option => option.value === formik.values.city_id)}
                                                                            onChange={option => formik.setFieldValue('city_id', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.city_id && formik.errors.city_id ? (
                                                                                <div className='text-danger small'>{formik.errors.city_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Postal Code <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter postal code"
                                                                            name="postal_code"
                                                                            maxLength={6}
                                                                            onInput={(event) => {
                                                                                let value = event.target.value;
                                                                                value = value.replace(/[^0-9]/g, '');
                                                                                event.target.value = value;
                                                                            }}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.postal_code}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.postal_code && formik.errors.postal_code ? (
                                                                                <div className='text-danger small'>{formik.errors.postal_code}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="main-nav-det">
                                                                    <h5 className='form-heading-bg'>Residential Address</h5>

                                                                    <div className="main-box-det-check mt-3">
                                                                        <label className="form-label users-table__checkbox mb-2" id="new_text">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="check"
                                                                                name="same_as_permanent_address"
                                                                                onChange={(e) => {
                                                                                    const isChecked = e.target.checked;
                                                                                    formik.setFieldValue("same_as_permanent_address", isChecked)
                                                                                    if (sameAddress == false) {
                                                                                        setSameAddress(true);
                                                                                    } else {
                                                                                        setSameAddress(false);
                                                                                    }
                                                                                }}
                                                                                onBlur={formik.handleBlur}
                                                                                checked={formik.values.same_as_permanent_address}
                                                                            />
                                                                            Same as Permanent Address
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {!sameAddress && <>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="input_box_section ">
                                                                            <label className='form-label'>Street Number <span className="text-danger">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm mb-1"
                                                                                placeholder="Enter street number "
                                                                                name="r_street_number"
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.r_street_number}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_street_number && formik.errors.r_street_number ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_street_number}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="input_box_section ">
                                                                            <label className='form-label'>Street <span className="text-danger">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm mb-1"
                                                                                placeholder="Enter street"
                                                                                name="r_street"
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.r_street}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_street && formik.errors.r_street ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_street}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="select_box_section ">
                                                                            <label className='margin-custom form-label'>Country <span className="text-danger">*</span></label>
                                                                            <Select
                                                                                className='custom-selector mb-1'
                                                                                options={residentialCountryOptions}
                                                                                name="r_country_id"
                                                                                value={residentialCountryOptions.find(option => option.value === formik.values.r_country_id)}
                                                                                onChange={option => { formik.setFieldValue('r_country_id', option.value); handleGetResidentialState(option.value) }}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_country_id && formik.errors.r_country_id ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_country_id}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="select_box_section  ">
                                                                            <label className='margin-custom form-label'>State <span className="text-danger">*</span></label>
                                                                            <Select
                                                                                className='custom-selector mb-1'
                                                                                options={residentialStateOptions}
                                                                                name="r_state_id"
                                                                                value={residentialStateOptions.find(option => option.value === formik.values.r_state_id)}
                                                                                onChange={option => { formik.setFieldValue('r_state_id', option.value); handleGetResidentialCity(option.value) }}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_state_id && formik.errors.r_state_id ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_state_id}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="select_box_section ">
                                                                            <label className='margin-custom form-label'>City <span className="text-danger">*</span></label>
                                                                            <Select
                                                                                className='custom-selector mb-1'
                                                                                options={residentialCityOptions}
                                                                                name="r_city_id"
                                                                                value={residentialCityOptions.find(option => option.value === formik.values.r_city_id)}
                                                                                onChange={option => { formik.setFieldValue('r_city_id', option.value) }}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_city_id && formik.errors.r_city_id ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_city_id}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="input_box_section ">
                                                                            <label className='form-label'>Postal Code <span className="text-danger">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm mb-1"
                                                                                placeholder="Enter postal code"
                                                                                name="r_postal_code"
                                                                                maxLength={6}
                                                                                onInput={(event) => {
                                                                                    let value = event.target.value;
                                                                                    value = value.replace(/[^0-9]/g, '');
                                                                                    event.target.value = value;
                                                                                }}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.r_postal_code}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.r_postal_code && formik.errors.r_postal_code ? (
                                                                                    <div className='text-danger small'>{formik.errors.r_postal_code}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>}
                                                            </div>
                                                        </div>
                                                    </div>



                                                </div>


                                            </>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Personal Details */}

                                    {/* Official Details */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                                            <span className="avatar avatar-md rounded text-dark border me-2">
                                                <i className="ti ti-user-plus fs-20" />
                                            </span>
                                            Official Details
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <>

                                                <div id="section2" className="section2">


                                                    <div className="main-nav-det">
                                                        <div className="admin_form_detail">
                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Official Contact Number <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter Official Contact Number"
                                                                            name="offical_contact_number"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.offical_contact_number}
                                                                            maxLength={10}
                                                                            onInput={(event) => {
                                                                                let value = event.target.value;
                                                                                value = value.replace(/[^0-9]/g, '');
                                                                                event.target.value = value;
                                                                            }}

                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.offical_contact_number && formik.errors.offical_contact_number ? (
                                                                                <div className='text-danger small'>{formik.errors.offical_contact_number}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="input_box_section ">
                                                                        <label className='form-label'>Official E-mail ID <span className="text-danger">*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Enter Official E-mail ID"
                                                                            name="offical_contact_email"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.offical_contact_email}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.offical_contact_email && formik.errors.offical_contact_email ? (
                                                                                <div className='text-danger small'>{formik.errors.offical_contact_email}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section  ">
                                                                        <label className='margin-custom form-label'>Department <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={departmentOptions}
                                                                            name="department_id"
                                                                            value={departmentOptions.find(option => option.value === formik.values.department_id)}
                                                                            onChange={option => formik.setFieldValue('department_id', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.department_id && formik.errors.department_id ? (
                                                                                <div className='text-danger small'>{formik.errors.department_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section ">
                                                                        <label className='margin-custom form-label'>Designation <span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={designationOptions}
                                                                            name="designation_id"
                                                                            value={designationOptions.find(option => option.value === formik.values.designation_id)}
                                                                            onChange={option => formik.setFieldValue('designation_id', option.value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.designation_id && formik.errors.designation_id ? (
                                                                                <div className='text-danger small'>{formik.errors.designation_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section">
                                                                        <label className='margin-custom form-label'>Reporting Manager: <span className="text-danger"></span>
                                                                            <OverlayTrigger
                                                                                placement="right"
                                                                                delay={{ show: 250, hide: 400 }}
                                                                                overlay={renderTooltip}
                                                                            >
                                                                                <i className="fa-solid fa-circle-info" style={{ cursor: 'pointer' }}></i>
                                                                            </OverlayTrigger>
                                                                        </label>
                                                                        <Select

                                                                            className=' custom-selector mb-1'
                                                                            options={userOptions}
                                                                            name="reporting_user_id"
                                                                            value={userOptions?.filter(option => (formik.values.reporting_user_id)?.includes(option.value))}
                                                                            // value={[75,76]}
                                                                            onChange={selectedOptions => {
                                                                                if (selectedOptions.length <= 2) {
                                                                                    formik.setFieldValue('reporting_user_id', selectedOptions.map(option => option.value));
                                                                                }
                                                                            }}
                                                                            onBlur={formik.handleBlur}
                                                                            isMulti={true}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.reporting_user_id && formik.errors.reporting_user_id ? (
                                                                                <div className='text-danger small'>{formik.errors.reporting_user_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="col-md-6 col-lg-4">
                                                                    <div className="select_box_section">
                                                                        <label className='margin-custom form-label'>Role<span className="text-danger">*</span></label>
                                                                        <Select
                                                                            className='custom-selector mb-1'
                                                                            options={roleOptions}
                                                                            name="role_id"
                                                                            value={roleOptions.find(option => option.value === formik.values.role_id)}
                                                                            onChange={handleRoleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <div className="help-block with-errors">
                                                                            {formik.touched.role_id && formik.errors.role_id ? (
                                                                                <div className='text-danger small'>{formik.errors.role_id}</div>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        {viewPermissions && roleModuleDetailData && (
                                                            <>
                                                                <div className="main_detail_form">
                                                                    <div className="main-nav-det">
                                                                        <h5 className='form-heading-bg'>Assigned Permissions</h5>
                                                                    </div>
                                                                    <div className="row">{renderPermissions(permissionList.assignModules, 'assignModules')}</div>
                                                                    <div className="main-nav-det">
                                                                        <h5 className='form-heading-bg'>Other Permissions</h5>
                                                                    </div>
                                                                    <div className="row">{renderPermissions(permissionList.notAssignModules, 'notAssignModules')}</div>

                                                                    {formik.errors.permissionList && (
                                                                        <div className="text-danger small">At least one permission must be selected</div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}

                                                    </div >



                                                </div >

                                            </>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Official Details */}
                                    {/* Account Credentials */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                                            <span className="avatar avatar-md rounded text-dark border me-2">
                                                <i className="ti ti-user-plus fs-20" />
                                            </span>
                                            Account Credentials
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <>
                                                {/* <Toaster /> */}

                                                {showLoader ?
                                                    <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                        <BeatLoader />
                                                    </div>
                                                    :
                                                    <div id="section3" className="section3">

                                                        <div className="main-nav-det">
                                                            <div className="admin_form_detail">
                                                                <div className="row">
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="input_box_section ">
                                                                            <label className='form-label'>Username<span className="text-danger">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm mb-1"
                                                                                placeholder="Enter Username"
                                                                                name="username"
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.username}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.username && formik.errors.username ? (
                                                                                    <div className='text-danger small'>{formik.errors.username}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-4">
                                                                        <div className="input_box_section ">
                                                                            <label className='form-label'>Password <span className="text-danger">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm mb-1"
                                                                                placeholder="Enter Password"
                                                                                name="password"
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                value={formik.values.password}
                                                                            />
                                                                            <div className="help-block with-errors">
                                                                                {formik.touched.password && formik.errors.password ? (
                                                                                    <div className='text-danger small'>{formik.errors.password}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>


                                                    </div>
                                                }
                                            </>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Account Credentials */}
                                </Accordion>
                                <div className="text-right">

                                    <button
                                        className='btn-stepper btn btn-danger'
                                        type="submit"
                                        variant="contained"
                                        // onClick={handleNext}
                                        disabled={disable}
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        {!disable ? "Submit" : <i className="fas fa-spinner fa-spin" style={{ color: "#fff" }}></i>}

                                    </button>
                                </div>


                            </form>
                    }
                </div>
            </Offcanvas.Body>
        </Offcanvas >
    )
}

export default AddEmployee